<script lang="ts" setup>
const { show: showErrorNotification } = useNotification()
const { hasCartItemErrors, errors } = useCart()
const { addToCartContext } = useAddToCart()
const addToCartDialog = useUiDialog('add-to-cart')

const cartUpsellProducts = computed(() => {
  return addToCartContext.value?.upsell || []
})

const resetAddedToCart = () => {
  addToCartContext.value = undefined
}

watch(addToCartContext, async (newVal) => {
  if (!errors.value.length && newVal !== undefined && newVal.suppress !== true) {
    addToCartDialog.open()
  }
})

watch(errors, (newVal) => {
  if (newVal.length) {
    showErrorNotification({ type: 'error', message: newVal.join(', ') })
  }
})
</script>

<template>
  <UiDialog
    class="added-to-cart"
    name="add-to-cart"
    dialog-type="responsive"
    @close="resetAddedToCart"
  >
    <template #dialogHeader>
      <span class="icon-check">
        <NuxtIcon name="icon:check" />
      </span>

      <span class="dialog__title">
        {{ $t('Added to cart') }}
      </span>
    </template>

    <CartAddedItem
      v-if="addToCartContext"
      :item="addToCartContext.product"
      :available-options="addToCartContext?.configurableOptions || []"
      :added-items="addToCartContext?.items || []"
    />

    <div
      v-if="cartUpsellProducts.length"
      class="complete-your-order"
    >
      <div class="complete-your-order__heading">
        {{ $t('Complete your order') }}
      </div>

      <ProductTile
        v-for="product in cartUpsellProducts"
        :key="product.id"
        class="complete-your-order__product-item product-item--horizontal"
        :product="product"
        :show-options="{ wishlist: true, colorVariants: false, labels: false }"
      >
        <template #additional>
          <ProductActionEs
            class="product-item__add-to-cart"
            :product="product"
          />
        </template>
      </ProductTile>
    </div>

    <div
      v-if="errors"
      class="error"
    >
      <ul>
        <li
          v-for="(error, index) in errors"
          :key="index"
        >
          <pre> {{ error }}</pre>
        </li>
      </ul>
    </div>

    <template
      v-if="addToCartContext"
      #dialogFooter
    >
      <div class="added-to-cart__product-buttons">
        <AppLink
          to="/cart/"
          class="added-to-cart__submit"
          data-testid="add-to-cart-view-cart"
          @click="addToCartDialog?.close()"
        >
          <span>{{ $t('View basket') }}</span>
        </AppLink>

        <!--
        <AppLink
          class="added-to-cart__link"
          to="/checkout/"
        >
          <span>{{ $t('Checkout') }}</span>
        </AppLink>
        -->

        <button
          class="added-to-cart__link"
          type="button"
          :disabled="hasCartItemErrors"
          @click="addToCartDialog?.close()"
        >
          <span>{{ $t('Continue shopping') }}</span>
        </button>
      </div>
    </template>
  </UiDialog>
</template>

<style>
@import url("~layers/components/Cart/Added.css");
</style>
